import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Timing } from '../../models/api/audit.model';

import { isApiAudit } from '../../utils/isApiAudit';
import { AuditService } from '../audit/audit.service';

@Injectable({
  providedIn: 'root',
})
export class AuditInterceptorService implements HttpInterceptor {
  constructor(private readonly auditService: AuditService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timing: Timing = {
      requestTime: String(new Date().getTime()),
      responseTime: '',
    };

    if (isApiAudit(request.url)) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      tap((response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {
          timing.responseTime = String(new Date().getTime());
          this.auditService.sendAudit(
            this.auditService.mapperAuditData(request, response.body, timing),
          );
        }
      }),
      catchError((error) => {
        timing.responseTime = String(new Date().getTime());
        this.auditService.sendAudit(
          this.auditService.mapperAuditError(request, error.error, timing),
        );
        return throwError(error);
      }),
    );
  }
}
